import React, {useEffect, useMemo, useState} from 'react'
import TitleComponent from '../../../components/TitleComponent/TitleComponent'
import KomponentiPregled from './components/KomponentiPregled'
import {useParams} from 'react-router-dom'
import KomponentiKreiraj from './components/KomponentiKreiraj'
import clsx from 'clsx'
import KontrolaKavliteta from './components/KontrolaKvaliteta'
import ZagaInfo from './components/ZagaInfo'
import {ZapisiProizvodnjeModel, ZapisiStavkeModel} from '../../../models/ZapisiProizvodnjeModel'
import {getZapisiNalogInfo} from '../../../api/zapisiProizvodnje'
import notifyToast from '../../../components/Toast/Toast'
import LoadingComponent from '../../../components/LoadingComponent/LoadingComponent'

const AktivniNaloziDetails = () => {
    const {id} = useParams()
    const IdFromURL = Number(id)

    const [selectedAction, setSelectedAction] = useState<number>(0)

    const [stavkeData, setstavkeData] = useState<Array<ZapisiStavkeModel>>([])
    const [data, setdata] = useState<ZapisiProizvodnjeModel | null>(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const params = {idZapisa: IdFromURL}
        setLoading(true)

        getZapisiNalogInfo(params)
            .then((response) => {
                const payload = response.data.data
                setdata(payload.nalozi?.[0] ?? null)
                setstavkeData(payload.stavke ?? [])
            })
            .catch((error) => notifyToast(false, error?.response?.data?.message))
            .finally(() => setLoading(false))
    }, [IdFromURL])

    const actionsList = useMemo(
        () => [
            {
                title: 'Komponente',
                subTitle: 'Pregled',
                component: <KomponentiPregled data={data as any} stavkeData={stavkeData} />,
            },
            {
                title: 'Komponente',
                subTitle: 'Kreiraj',
                component: <KomponentiKreiraj initialData={data as any} />,
            },
            {
                title: 'Kontrola kvaliteta',
                subTitle: 'Kreiraj',
                component: <KontrolaKavliteta initialData={data as any} />,
            },
            {
                title: 'Žaga info',
                subTitle: 'Kreiraj',
                component: <ZagaInfo initialData={data as any} />,
            },
        ],
        [data, stavkeData]
    )

    return (
        <div className='row g-4'>
            {/* LEFT: compact actions panel */}
            <div className='col-12 col-lg-3'>
                <div className='card h-100'>
                    {/* compact header */}
                    <div className='card-header py-3'>
                        <div className='d-flex align-items-center justify-content-between'>
                            <TitleComponent name='Odaberi akciju' />
                            <span className='badge bg-light text-dark border'>
                {selectedAction + 1}/{actionsList.length}
              </span>
                        </div>
                    </div>

                    <div className='card-body p-3'>
                        {/* Tablet-friendly grid: 2 columns on md, 1 column on lg (left sidebar) */}
                        <div className='row g-2 row-cols-1 row-cols-md-2 row-cols-lg-1'>
                            {actionsList.map((action, index) => {
                                const active = selectedAction === index

                                return (
                                    <div className='col' key={`${action.title}-${action.subTitle}-${index}`}>
                                        <button
                                            type='button'
                                            onClick={() => setSelectedAction(index)}
                                            className={clsx(
                                                'w-100 text-start rounded-3 border d-flex align-items-center gap-3',
                                                'px-3 py-2',
                                                'shadow-sm',
                                                active ? 'bg-primary border-primary' : 'bg-white border-gray-200'
                                            )}
                                            style={{
                                                // keeps height compact on tablets
                                                minHeight: 56,
                                            }}
                                        >
                                            {/* small index pill */}
                                            <span
                                                className={clsx(
                                                    'badge rounded-pill',
                                                    active ? 'bg-white text-primary' : 'bg-light text-dark border'
                                                )}
                                            >
                        {index + 1}
                      </span>

                                            <div className='flex-grow-1'>
                                                <div className={clsx('fw-bold', active ? 'text-white' : 'text-dark')} style={{lineHeight: 1.15}}>
                                                    {action.title}
                                                </div>
                                                <div className={clsx('small', active ? 'text-white-50' : 'text-muted')} style={{lineHeight: 1.15}}>
                                                    {action.subTitle}
                                                </div>
                                            </div>

                                            {/* right chevron 느낌 */}
                                            <span className={clsx('fw-bold', active ? 'text-white' : 'text-muted')}>›</span>
                                        </button>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>

            {/* RIGHT: content */}
            <div className='col-12 col-lg-9'>
                {loading ? <LoadingComponent /> : actionsList[selectedAction]?.component}
            </div>
        </div>
    )
}

export default AktivniNaloziDetails
